import React, { useState, useEffect } from "react";
import { Collapse, Container, NavbarToggler, NavLink } from "reactstrap";
import Scrollspy from "react-scrollspy";
import { Link, useLocation } from "react-router-dom";
// Import Images
import logodark from "../../../assets/INFINITY.png";
import logolight from "../../../assets/images/logo-light.png";

const Navbar = ({ onChangeLayoutMode, layoutModeType },) => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [navClass, setNavClass] = useState("");
  const [textColor, setTextColor] = useState("text-dark");
  const [activeItem, setActiveItem] = useState("home");
  const [currentLogo, setCurrentLogo] = useState(logodark); // Track the current logo
  const location = useLocation();

  const toggle = () => setIsOpenMenu(!isOpenMenu);

  useEffect(() => {
    const handleScroll = () => {
      const scrollup = document.documentElement.scrollTop;

      if (scrollup > 50) {
        setNavClass("is-sticky");
        setTextColor("text-white"); // Dark background, white text
        setCurrentLogo(logolight); // Switch to light logo
      } else {
        setNavClass("");
        setTextColor("text-dark"); // Transparent/white background, black text
        setCurrentLogo(logodark); // Switch to dark logo
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (location.pathname === "/Landing" || location.pathname === "/") {
      const hash = location.hash.replace("#", "") || "home";
      setActiveItem(hash);
    } else {
      const path = location.pathname.replace("/", "");
      setActiveItem(path);
    }
  }, [location]);

  const handleNavClick = (itemId) => {
    setActiveItem(itemId);
    setIsOpenMenu(false);
  };

  const isItemActive = (itemId) => {
    if (location.pathname === "/Landing" || location.pathname === "/") {
      return activeItem === itemId;
    }
    return location.pathname.includes(itemId);
  };

  return (
    <React.Fragment>
      <nav
        className={`navbar navbar-expand-lg navbar-landing fixed-top ${navClass}`}
        id="navbar"
      >
        <Container>
          <Link className="navbar-brand" to="/Landing">
            <img
              src={currentLogo}
              alt="logo"
              style={{ height: "25px" }}
            />
          </Link>

          <NavbarToggler
            className={`navbar-toggler py-0 fs-20 ${textColor}`}
            onClick={toggle}
            type="button"
            aria-expanded={isOpenMenu}
            aria-label="Toggle navigation"
          >
            <i className="mdi mdi-menu"></i>
          </NavbarToggler>

          <Collapse
            isOpen={isOpenMenu}
            className="navbar-collapse"
            id="navbarSupportedContent"
          >
            <Scrollspy
              offset={-18}
              items={[
                "home",
                "services",
                "features",
                "reviews",
                "contact",
                "AboutUs",
                "career",
                "integrations",
                "pricing",
              ]}
              currentClassName="active"
              className="navbar-nav mx-auto mt-2 mt-lg-0"
              id="navbar-example"
            >
              {["home", "features", "services", "reviews", "contact"].map(
                (item, idx) => (
                  <li className="nav-item" key={idx}>
                    <NavLink
                      className={`fs-14 ${textColor} ${isItemActive(item) ? "active" : ""
                        }`}
                      href={`/Landing#${item}`}
                      onClick={() => handleNavClick(item)}
                    >
                      {item.charAt(0).toUpperCase() + item.slice(1)}
                    </NavLink>
                  </li>
                )
              )}
              <li className="nav-item">
                <Link to="/AboutUs">
                  <NavLink
                    className={`fs-14 ${textColor} ${isItemActive("AboutUs") ? "active" : ""
                      }`}
                    onClick={() => handleNavClick("AboutUs")}
                  >
                    About Us
                  </NavLink>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/CareerPage">
                  <NavLink
                    className={`fs-14 ${textColor} ${isItemActive("career") ? "active" : ""
                      }`}
                    onClick={() => handleNavClick("career")}
                  >
                    Career
                  </NavLink>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/pricing">
                  <NavLink
                    className={`fs-14 ${textColor} ${isItemActive("pricing") ? "active" : ""
                      }`}
                    onClick={() => handleNavClick("pricing")}
                  >
                    Pricing
                  </NavLink>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/IndustrialIntegration">
                  <NavLink
                    className={`fs-14 ${textColor} ${isItemActive("integrations") ? "active" : ""
                      }`}
                    onClick={() => handleNavClick("integrations")}
                  >
                    Integrations
                  </NavLink>
                </Link>
              </li>
            </Scrollspy>
            <div>
              <Link to="/Login" className={`btn btn-primary`}>
                Sign in
              </Link>
            </div>
          </Collapse>
        </Container>
      </nav>
    </React.Fragment>
  );
};

export default Navbar;
